import { render } from "./RatingButton.vue?vue&type=template&id=1a0b5f2f"
import script from "./RatingButton.vue?vue&type=script&lang=js"
export * from "./RatingButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__